
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Helmet } from "react-helmet";

export default function Terms() {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Terms of Service - UnitCodex</title>
        <meta name="description" content="UnitCodex Terms of Service - Guidelines for using our unit conversion and historical measurement information tools." />
        <link rel="canonical" href="https://unitcodex.com/terms" />
      </Helmet>
      
      <Card className="bg-manuscript-background/90">
        <CardHeader>
          <CardTitle className="text-4xl font-cinzel text-center">Terms of Service</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-lg max-w-none text-manuscript-primary/80 space-y-6">
          <section>
            <h2 className="text-2xl font-cinzel mb-4">Agreement to Terms</h2>
            <p>
              By accessing and using UnitCodex, you agree to be bound by these Terms of Service and all applicable laws and regulations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Use of Service</h2>
            <p>
              Our unit conversion tool and historical information are provided for general informational purposes only. While we strive for accuracy:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Conversions should be independently verified for critical applications</li>
              <li>Historical information is provided as educational content</li>
              <li>The service is provided "as is" without any guarantees</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Intellectual Property</h2>
            <p>
              All content on this website, including but not limited to text, graphics, logos, historical information, and conversion tools, is the property of UnitCodex and is protected by intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Acceptable Use</h2>
            <p>
              You agree not to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to interfere with the proper functioning of the website</li>
              <li>Access the service through automated means</li>
              <li>Copy or modify the website's software</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Limitation of Liability</h2>
            <p>
              UnitCodex shall not be liable for any damages arising from:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>The use or inability to use our services</li>
              <li>Errors in conversion calculations</li>
              <li>Inaccuracies in historical information</li>
              <li>Any loss or damage of any kind incurred as a result of using our service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of the service after any changes constitutes acceptance of the new terms.
            </p>
            <p className="mt-2">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
